import { FC, forwardRef } from 'react';
import { IonLabel } from '@ionic/react';
import { AllieLabelProps } from './Label.types';

export const AllieLabel: FC<AllieLabelProps> = forwardRef((props, ref) => (
  <IonLabel ref={ref} {...props} />
));
